import API from 'services/API/index';

export default function getExternalServicesToken(query) {
  return API.request({
    method: 'GET',
    url: `/services${query || ''}`,
  });
}
